import { MARQUEE_ITEMS } from "../lib/site";

export default function Marquee() {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            className="relative border-y border-white/10 bg-panel/60 py-5 overflow-hidden"
            data-testid="marquee-band"
        >
            <div className="marquee-track" data-testid="marquee-track">
                {items.map((it, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-6 pr-6 font-display font-bold uppercase tracking-tight text-xl sm:text-2xl text-cloud/80 whitespace-nowrap"
                    >
                        {it}
                        <span className="text-ambra text-base">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
